export const objectPropertyTypes = [
  'text',
  'number',
  'date',
  'toggle',
  'select-1',
  'multi-select',
] as const

export type PropertyType = (typeof objectPropertyTypes)[number]

export function isObjectPropertyType(value: string): value is PropertyType {
  return objectPropertyTypes.includes(value as PropertyType)
}
